var PaymentMethodsEnum = /*#__PURE__*/function (PaymentMethodsEnum) {
  PaymentMethodsEnum["Googlepay"] = "googlepay";
  PaymentMethodsEnum["Applepay"] = "applepay";
  PaymentMethodsEnum["Paypal"] = "paypal";
  PaymentMethodsEnum["Docomo"] = "docomo";
  // payment method is removed, but type may be used in settings page for old subscriptions
  PaymentMethodsEnum["Adyen"] = "adyen";
  return PaymentMethodsEnum;
}({});

export { PaymentMethodsEnum as P };
//# sourceMappingURL=subscriptionPlanModel-de0d0313.js.map
